import React from "react";
import "./index.scss";
import { IMdaePopupFooterStartButtons } from "./index";
const MdaePopupFooterStartButtons: React.FC<IMdaePopupFooterStartButtons> = (
  props
) => {
  return <div className={"mdae-popup-start-buttons"}>{props.children}</div>;
};
export { MdaePopupFooterStartButtons };
